import { getDetectedCountry } from './country';
import { inputById, inputValue } from './dom';
import { marketingData, multiState, placeData } from './state';
import type { AnalyticsFormData, ServiceEntry, WebhookPayload } from './types';
import { getDeviceType } from './utils';

/**
 * Identyfikatory tego formularza, po nich rozpoznajemy w CRM/analityce,
 * z którego formularza przyszedł deal. Stary formularz wysyła `multitrip_A`.
 */
export const FORM_VARIANT = 'multitrip_B';
export const FORM_LANDING_VARIANT = 'with_multitrip';

export function serializeForm(): WebhookPayload {
  const isMulti = inputValue('tripType') === 'multitrip';
  const isReturn = inputValue('tripType') === 'return';

  const customerDetails = {
    submission_id: crypto.randomUUID(),
    // Formularz docelowy nie zbiera imienia ani telefonu, dane uzupełnia proposal-view.
    full_name: '',
    telephone: '',
    country_of_origin: getDetectedCountry(),
    source: window.location.origin + window.location.pathname,
    request_details: inputValue('notes').trim(),
    email: inputValue('email').trim(),
    consent: inputById('marketing')?.checked ?? false,
    device_type: getDeviceType(),
    ab_variant: FORM_VARIANT,
    ab_landing_variant: FORM_LANDING_VARIANT,
    marketing: { ...marketingData, click_id: marketingData.im_ref || '' },
  };

  const servicesData: Record<string, ServiceEntry> = {};
  if (!isMulti) {
    const pickupVal = inputValue('pickup').trim();
    const destVal = inputValue('destination').trim();
    const pax = Number(inputValue('passengers')) || 0;
    const bags = Number(inputValue('bags')) || 0;

    servicesData.service_1 = {
      pickup: pickupVal,
      destination: destVal,
      pickup_date: `${inputValue('pickupDate')} ${inputValue('pickupTime')}`,
      passengers: pax,
      carry_on_luggage: 0,
      checked_luggage: bags,
      stops: null,
    };
    if (isReturn) {
      // Powrót = ta sama trasa odwrócona
      servicesData.service_1_return = {
        pickup: destVal,
        destination: pickupVal,
        pickup_date: `${inputValue('returnDate')} ${inputValue('returnTime')}`,
        passengers: pax,
        carry_on_luggage: 0,
        checked_luggage: bags,
        stops: null,
      };
    }
  } else {
    multiState.trips.forEach((trip, idx) => {
      servicesData[`service_${idx + 1}`] = {
        pickup: trip.pickup,
        destination: trip.destination,
        pickup_date: `${trip.date} ${trip.time}`,
        passengers: trip.pax,
        carry_on_luggage: 0,
        checked_luggage: trip.bags,
        stops: trip.stopovers.filter((s) => s.trim() !== ''),
        notes: trip.notes,
      };
    });
  }

  return [{ customer_details: customerDetails, services: [servicesData] }];
}

export function extractFormDataForAnalytics(payload: WebhookPayload): AnalyticsFormData {
  const services = payload[0].services[0];
  const service1 = services.service_1;
  if (!service1) return { transfer_type: 'MULTI_TRIP' };

  const transferType = services.service_1_return ? 'RETURN' : 'ONE_WAY';
  const pickupDateTime = service1.pickup_date ? service1.pickup_date.replace(' ', 'T') + ':00' : '';

  return {
    pickup_country: placeData.pickup?.country || '',
    pickup_city: placeData.pickup?.city || '',
    destination_country: placeData.destination?.country || '',
    destination_city: placeData.destination?.city || '',
    passenger_count: service1.passengers,
    transfer_type: transferType,
    pickup_location: service1.pickup,
    destination: service1.destination,
    pickup_coordinates: placeData.pickup?.coordinates || { longitude: 0, latitude: 0 },
    destination_coordinates: placeData.destination?.coordinates || { longitude: 0, latitude: 0 },
    pickup_local_date: pickupDateTime,
  };
}
